import {Component, EventEmitter, Input, Output} from '@angular/core';
import { RouterModule } from '@angular/router';
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-menu-item',
  standalone: true,
  imports: [RouterModule, TranslateModule],
  templateUrl: './menu-item.component.html',
  styleUrl: './menu-item.component.scss'
})
export class MenuItemComponent {
  @Input() label: string = '';
  @Input() route: string = '';
  @Output() itemClicked = new EventEmitter<void>();

  onItemClick() {
    this.itemClicked.emit();
  }
}
